import { DependencyModule } from 'brandi';
import { LinkWrapperHost, skimlinksLinkWrapper, trackonomicsLinkWrapper } from './linkWrappers/index.js';
import { V1_TOKENS } from './v1Tokens.js';
const v1Dependencies = new DependencyModule();
// @todo These two injections aren't working. figure out why? (and remove from frontend container)
// injected(LinkEmbed, V1_TOKENS.linkWrapperHost);
// injected(LinkWrapperHost, V1_TOKENS.linkWrapperFns);
// @todo these two binds aren't working. figure out why?
// v1Dependencies.bind(V1_TOKENS.linkWrapperHost)
//     .toInstance(LinkWrapperHost)
//     .inSingletonScope();
// v1Dependencies.bind(V1_TOKENS.linkEmbedGenerator)
//     .toInstance(LinkEmbed)
//     .inSingletonScope();
const bindLinkWrapperFns = (container) => {
    container
        .bind(V1_TOKENS.linkWrapperFns)
        .toInstance(() => {
        return {
            Skimlinks: skimlinksLinkWrapper,
            Trackonomics: trackonomicsLinkWrapper,
        };
    })
        .inSingletonScope();
    container.bind(V1_TOKENS.linkWrapperHost).toInstance(LinkWrapperHost).inSingletonScope();
};
export { bindLinkWrapperFns, v1Dependencies };
//# sourceMappingURL=v1DependencyModule.js.map